'use strict';

const Rlite = require('rlite-router');

module.exports = class {
  constructor(slideshow) {
    const router = new Rlite();

    router.add('', () => slideshow.to(0));
    router.add(':slide', (req) => slideshow.to(parseInt(req.params.slide, 10)));

    function processHash() {
      const hash = location.hash || '#';
      router.run(hash.slice(1));
    }
    window.addEventListener('hashchange', processHash);
    processHash();
  }
};
